import http from '../http'

export default {
  // 获取公会信息
  getGuildInfo(data: object) {
    return http.post('/web/guild/info', data)
  },
  // 获取公会列表
  getGuildList(data: object) {
    return http.post('/web/guild/list', data)
  },
  // 获取公会列表
  useQueryGuildList(data: object) {
    return http.usePost('/web/guild/list', data)
  },
  // 申请加入公会
  applyGuildJoin(data: object) {
    return http.post('/web/guild/apply_join', data)
  },
  // 获取申请列表
  getGuildApplyList(data: object) {
    return http.post('/web/guild/apply_list', data)
  },
  // 处理申请
  handleGuildApplyProcess(data: object) {
    return http.post('/web/guild/apply_process', data)
  },
  // 获取公会成员列表
  getGuildMemberList(data: object) {
    return http.post('/web/guild/member', data)
  },
  // 移出公会成员
  removeGuildMember(data: object) {
    return http.post('/web/guild/member/remove', data)
  },
  // 设置或取消管理员
  setGuildMemberRole(data: object) {
    return http.post('/web/guild/member/set_role', data)
  },
  // 获取粉丝列表
  getGuildFansList(data: object) {
    return http.post('/web/guild/can_invite_fans', data)
  },
  // 邀请粉丝加入公会
  inviteGuildFans(data: object) {
    return http.post('/web/guild/invite_fans', data)
  },
  // 公会主页 banner
  getGuildBanner(data: object) {
    return http.post('/web/guild/banner', data)
  },
  // 获取公会账单
  getGuildBill(data: object) {
    return http.post('/web/guild/bill', data)
  },
  // 获取公会账单列表
  getGuildBillList(data: object) {
    return http.post('/web/guild/bill/list', data)
  },
  // 获取个人账单
  getPersonalBill(data: object) {
    return http.post('/web/guild/member/bill', data)
  },
  // 获取个人账单列表
  getPersonalBillList(data: object) {
    return http.post('/web/guild/member/bill/list', data)
  },
  // 获取外管或BD绑定公会列表
  getBindGuildList(data: object) {
    return http.post('/web/guild/guild_list', data)
  },
  // 获取BD成员列表
  getGuildBDMemberList(data: object) {
    return http.post('/web/guild/bd_member', data)
  },
  // 获取上级外管列表
  getGuildParentList(data: object) {
    return http.post('/web/guild/ext_admin', data)
  },
  // 获取阿语地区邀请者ID
  getGuildInviteAreaID(data: object) {
    return http.post('/web/guild/get_ar_inviter_uid', data)
  },
  // 获取外管或BD用户信息
  getExtAdminBdInfo(data: object) {
    return http.post('/web/guild/get_ext_admin_bd_info', data)
  },
  // 创建公会
  createGuild(data: object) {
    return http.post('/web/guild/apply_create', data)
  },
  // 获取公会创建申请列表
  getGuildCreateApplyList(data: object) {
    return http.post('/web/guild/apply_create_list', data)
  },
  // 处理公会创建申请
  handleGuildCreateApply(data: object) {
    return http.post('/web/guild/apply_create_process', data)
  },
  // 获取外管红点数量
  getGuildExtAdminRedDot(data: object) {
    return http.post('/web/guild/get_ext_admin_red_dot', data)
  },
  // 获取个人数据详情
  getPersonalData(data: object) {
    return http.post('/web/guild/get_self_info', data)
  },
  // 获取外管成员列表
  getGuildExtAdminMember(data: object) {
    return http.post('/web/guild/ext_admin_member', data)
  },
  // 获取外管成员总数
  getGuildExtAdminMemberCount(data: object) {
    return http.post('/web/guild/get_ext_admin_member_count', data)
  },
  // 数据中心-公会数据-钻石
  getGuildDataCenterAllDiamondsDate(data: object) {
    return http.post('/web/guild/datacenter/all_diamonds_date', data)
  },
  // 数据中心-公会数据-今日明细（已废弃，请使用 getGuildDataCenterMemberDiamondsRangeDayList）
  getGuildDataCenterMemberDiamondsTodayList(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_today_list', data)
  },
  // 数据中心-公会数据-按日期范围明细列表
  getGuildDataCenterMemberDiamondsRangeDayList(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_range_day_list', data)
  },
  // 数据中心-个人数据
  getGuildDataCenterMemberDiamondsDate(data: object) {
    return http.post('/web/guild/datacenter/member_diamonds_date', data)
  },
  // 数据中心-获取公会旗下主播基础信息
  getGuildDataCenterMemberBaseInfo(data: object) {
    return http.post('/web/guild/datacenter/member/baseinfo', data)
  },
}
